import { z } from 'zod';
import { UserRoleSchema } from './auth.js';
/**
 * Roles that an admin can assign when inviting or updating a user. OWNER is excluded from
 * invitations — the initial owner is bootstrapped via OWNER_EMAIL.
 */
export const InvitableRoleSchema = z.enum(['ADMIN', 'MEMBER']);
/** Request body for inviting a new user to the organisation. */
export const InviteUserSchema = z.object({
    email: z.email(),
    role: InvitableRoleSchema,
});
/** Request body for updating a user's role. */
export const UpdateUserRoleSchema = z.object({
    role: UserRoleSchema,
});
/** Request body for updating the current user's display name. */
export const UpdateProfileSchema = z.object({
    name: z.string().min(1, 'Name is required'),
});
//# sourceMappingURL=users.js.map